import { render, staticRenderFns } from "./ListLink.vue?vue&type=template&id=19c73dec&scoped=true"
import script from "./ListLink.vue?vue&type=script&lang=js"
export * from "./ListLink.vue?vue&type=script&lang=js"
import style0 from "./ListLink.vue?vue&type=style&index=0&id=19c73dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c73dec",
  null
  
)

export default component.exports